
export const minus = `<svg aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
<path d="M32 16.16c0 1.040-0.8 1.84-1.84 1.84h-28.32c-1.040 0-1.84-0.8-1.84-1.84v-0.32c0-1.040 0.8-1.84 1.84-1.84h28.24c1.040 0 1.84 0.8 1.84 1.84 0.080 0 0.080 0.32 0.080 0.32z"></path>
</svg>`;
